import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  Button,
} from "@chakra-ui/react";

interface CreateJobModalProps {
  isOpen: boolean;
  onClose: () => void;
  newJobName: string;
  setNewJobName: (name: string) => void;
  handleCreateJob: () => void;
}

const CreateJobModal: React.FC<CreateJobModalProps> = ({
  isOpen,
  onClose,
  newJobName,
  setNewJobName,
  handleCreateJob,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create New Job</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder="Enter new job name"
            value={newJobName}
            onChange={(e) => setNewJobName(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="purple" onClick={handleCreateJob}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateJobModal;